import React from "react";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import { makeStyles } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { Container } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { TextField } from "@material-ui/core";
import * as yup from 'yup';

import { token_authorization } from "../actions/purchaseAction";

const useStyles = makeStyles((theme) =>({
    button:{
    color: 'black',
    backgroundColor: theme.palette.primary['300'],
    '&:hover':{
        backgroundColor:theme.palette.primary['400']
    },
    container:{
      backgroundColor: 'white',
      borderRadius: '5px'
    },
  },
}))

export const validationSchema = yup.object({
  token: yup
    .string()
    .length(6, '6桁の認証番号を入力してください')
    .required('認証番号は必須です'),
});

const TokenFormComponent = () => {

    const dispatch = useDispatch()
    const classes = useStyles()

    const formik = useFormik({
        initialValues: {
          token: '',
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
          const data = {
            token: values.token
          }
          dispatch(token_authorization(data))
        },
    });

    return(
      <Container className={classes.container} maxWidth="md">
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={2} direction="column">
            <Grid item>
              <TextField
                fullWidth
                id="token"
                name="token"
                label="認証番号"
                value={formik.values.token}
                onChange={formik.handleChange}
                error={formik.touched.token && Boolean(formik.errors.token)}
                helperText={formik.touched.token && formik.errors.token}
              />
            </Grid>
            <Grid item>
              <Button
              className={classes.button} 
                fullWidth
                type="submit"
                variant="contained"
                color="primary"
              >
                送信する
              </Button>
            </Grid>
          </Grid>
        </form>
      </Container>
    )
}

export default TokenFormComponent